import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex'
import PagesApi from '@/api/pages'
import { actions as pagePermissionActions } from '@/vuex/modules/ui/pagePermission/constants'
import { actions as currentAgencyActions } from '@/vuex/modules/currentAgency/constants'
import { actions as currentAdvertiserActions } from '@/vuex/modules/currentAdvertiser/constants'
import { actions as accountActions } from '@/vuex/modules/account/constants'

import { resetPasswordRoutes } from '@/router/resetPassword'
import { inviteRoutes } from '@/router/invite'
import { adminRoutes } from '@/router/admin'
import { advertiserRoutes } from '@/router/advertiser'
import { loginLpRoutes } from '@/router/loginLp'

import Login from '@/pages/Login'
import NoPermission from '@/pages/NoPermission'
import NotFound from '@/pages/NotFound'
import AuthMiddleware from '@/middlewares/authMiddleware'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  // ページ表示権限がなかった時に表示されるページ
  {
    path: '/no_permission',
    name: 'NoPermission',
    component: NoPermission,
  },
  {
    path: '*',
    component: NotFound,
  },
]

// パスワードリセットのroutingを追加
routes.push(...resetPasswordRoutes)
// 招待のroutingを追加
routes.push(...inviteRoutes)

// 管理系routingを追加
routes.push(...adminRoutes)

// 広告主系routingを追加
routes.push(...advertiserRoutes)

// ログイン後のページについて
routes.push(...loginLpRoutes)

const router = new Router({
  mode: 'history',
  routes: routes,
})

router.beforeEach((to, from, next) => {
  // 認証が必要なページか否かを取得
  const isNeedLogin = to.matched.some(record => record.meta.requireAuth)
  if (isNeedLogin) {
    // 認証が必要なroutingの場合
    routingControlNeedLogin(to, next)
  } else {
    // 認証が必要ないroutingの場合
    routingControlNotNeedLogin(to, next)
  }
})

const routingControlNotNeedLogin = (to, next) => {
  if (to.name === 'Login' && AuthMiddleware.isLoggedIn()) {
    /*
     * ログイン画面は認証が必要ないページだが、
     * すでにログインしている状態で訪れた時はindexページへいかなければならない
     * これいるかな？？？ ブラウザバックしてログインページにきたときにバグるぞ
     */
    next('/loginlp/report')
  } else {
    next()
  }
}

// 認証が必要なroutingの場合
const routingControlNeedLogin = async (to, next) => {
  if (!window.navigator.onLine) {
    throw new Error('インターネットに接続できません。')
  }

  const path = to.fullPath
  if (!AuthMiddleware.isLoggedIn()) {
    store.dispatch('loginAuth/STORE_REDIRECT_PATH', path)
    // ログインしていない場合  ログイン画面へ
    next('/')
  } else {
    /**
     * そのページへのアクセス権限情報
     *   アクセス認可(isAuthorized)
     *   アクセス権限(permissionLevel)
     * の取得
     */
    let isAuthorized
    try {
      // ページのアクセス可否を取得
      const pagePermission = await PagesApi.getPagePermission(path)
      isAuthorized = pagePermission.access
      // 権限レベルをセット
      const permissionLevel = pagePermission.level
      await store.dispatch(pagePermissionActions.SET_PERMISSION_LEVEL, {
        permissionLevel,
      })
    } catch (e) {
      // セッションが切れるなどのエラーが起こった場合は、
      // ログアウトさせてログイン画面へ
      AuthMiddleware.logout()
      store.dispatch('loginAuth/STORE_REDIRECT_PATH', path)
      next('/')
      const error = new Error(
        'ページのセッションが切れました。再度ログインしてください。',
      )
      throw error
    }
    if (isAuthorized) {
      if (path.includes('advertisers') && path.includes('agencies')) {
        // パンくずを表示に使用するため、代理店idを取得してvuex管理する
        const id = to.params.agencyId
        await store.dispatch(currentAgencyActions.INITIALIZE, {
          agency: { id },
        })
        // パンくずを表示に使用するため、広告主idもvuex管理する
        const advertiserId = to.params.advertiserId
        await store.dispatch(currentAdvertiserActions.GET, { advertiserId })
      }
      // システムオーナー情報を持ってくる
      await store.dispatch(accountActions.GET_SYSTEM_OWNER)

      // アクセス可の場合は該当ページへ
      next()
    } else {
      // アクセス不可の場合「権限がありません」ページへ移動
      next('/no_permission')
    }
  }
}

export default router
